module.exports = __webpack_public_path__ + "img/Avatar-43.0effe8b9.svg";